<template>
  <div class="col">
    <div class="row">
      <b-button class="btn btn-success ml-2 mb-2" @click="newTeam()">
        Criar uma nova Equipe
      </b-button>
    </div>
    <div class="row limit-table">
      <table class="table">
        <thead class="letter-orange">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Nome</th>
            <th scope="col">Quantidade de Membros</th>
            <th scope="col">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="team in teams" v-bind:key="team.id">
            <th scope="row">
              {{ team.id }}
            </th>
            <td>
              {{ team.name }}
            </td>
            <td>
              {{ team.members_count }}
            </td>
            <td>
              <div class="btn btn-warning mr-1" @click="editTeam(team.id)">
                <i class="fas fa-eye" aria-label="Ver ou Editar"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Stack, StackItem } from 'vue-stack-grid';
import { mapActions, mapGetters, mapState } from 'vuex';
import Card from '../../../components/Journal/Card.vue';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'journal',
  mixins: [makeToast],
  components: { Stack, StackItem, Card },
  data() {
    return {
      teams: [],
      Fields: {
        name: '',
      },
    };
  },
  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapGetters('journal', ['setTeams']),
  },
  created() {
    this.getTeams(this.dadosUsuario.id)
      .then((response) => {
        console.log(response);
        this.teams = response.data.data;
      })
      .catch((error) => {
        console.log(error);
        this.makeToast(
          'Oopss!',
          'Não foi possivel carregar as equipes!',
          'danger'
        );
      });
  },
  methods: {
    ...mapActions('journal', ['getTeams', 'createTeam']),
    newTeam() {
      const data = {
        name: this.Fields.name,
      };

      this.createTeam(this.dadosUsuario.id, data)
        .then((response) => {
          this.makeToast('Sucesso!', 'Equipe nova criada com sucesso');
          setTimeout(() => {
            this.editTeam(response.data.data.id);
          }, 1000);
        })
        .catch((error) => {
          this.makeToast('Oopss!', error, 'danger');
        });
    },
    editTeam(id) {
      this.$router.push({
        name: 'journal-view-edit-team',
        params: { id },
      });
    },
  },
};
</script>

<style scoped>
.border-radius {
  border-radius: 8px;
}

.no-text-decoration:hover {
  color: var(--orange-primary);
  text-decoration: none;
}

.table td,
.table th {
  vertical-align: middle;
}
</style>
